<template>  
  <v-container fluid>
    <form>
      <!-- Data Table -->      
      <v-data-table 
                :items="listaDeMembros"
                :headers="headersMembros"
                :loading="isLoadingMembros" 
                class="elevation-1"                          
              >
              <template v-slot:item.renda_bruta="{item}">
                  <span v-text="formataEmReais(item.renda_bruta)"></span>
              </template>              
      </v-data-table>
      <br />   
      <v-text-field         
        :value="fmtrndbruta"
        label="Renda mensal bruta familiar (Soma de todos os membros do grupo familiar)" 
        class="font-weight-bold"       
        disabled
      ></v-text-field>
      <v-text-field
        :value="fmtrndbrutapercapita"          
        label="Renda per capita (renda mensal bruta total familiar dividido pelo número de todos os membros do grupo familiar)"
        class="font-weight-bold"
        disabled
      ></v-text-field>
       <v-text-field
        :value="fmtrndbrutapercapitareferencial"
        label="Renda per capita (Referencial = 1 salário mínimo vigente)"
        class="font-weight-bold"
        disabled
      ></v-text-field>   
    </form>
  </v-container>

</template>

<script>
import MembroFamiliar from "@/models/membrofamiliar";
import DadosPessoais from "@/models/dadosPessoais";
import * as MembroFamiliarService from "@/services/membro-familiar.service";


export default {  
  props: {
    preMatricula: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dadosPessoais: new DadosPessoais(),
      membroFamiliar: new MembroFamiliar('','', '', '', '', '', '', ''),                  
      fmtrndbrutapercapitareferencial: 0,
      fmtrndbruta: 0,
      fmtPeriodoRelatorio: 0,      
      fmtrndbrutapercapita: 0,      
      isLoadingMembros: false,      
      listaDeMembros: [],      
      headersMembros: [        
          {
          text: "Nome do Membro familiar",
          align: "start",
          sortable: true,
          value: "nome",
        },
        {
          text: "Idade",
          align: "start",
          sortable: true,
          value: "idade",
        },
         {
          text: "Parentesco",
          align: "start",
          sortable: true,
          value: "parentesco",
        },               
        {
          text: "Estado Civil",
          align: "start",
          sortable: false,
          value: "estado_civil",
        },
        {
          text: "Profissão",
          align: "start",
          sortable: false,
          value: "profissao",
        },
        {
          text: "Renda Bruta",
          align: "start",
          sortable: false,
          value: "renda_bruta",
        },
        {
          text: "Período(Meses)",
          align: "start",
          sortable: false,
          value: "periodo",
        },        
      ],
    };
  },
  mounted() {        
    this.loadMembros();    
    this.calculoRendaPerCapta();
    this.getSalarioReferenciaPerCapta();
  }  
  ,methods: {     
    getSalarioReferenciaPerCapta(){
      MembroFamiliarService.getSalarioReferenciaPerCaptaPorId(this.preMatricula.id).then( ( res ) => 
        {(this.fmtrndbrutapercapitareferencial = res.data), this.fmtrndbrutapercapitareferencial = this.fmtrndbrutapercapitareferencial * 1,
          this.fmtrndbrutapercapitareferencial = this.fmtrndbrutapercapitareferencial.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});         
        }) ;
    }, 
    loadMembros(){
      this.listaDeMembros = [];
      this.isLoadingMembros = true;    
      this.editandoMembro = false;      
      MembroFamiliarService.getMembrosPorCandidatoId(this.preMatricula.id)      
      .then( (res) => {(this.listaDeMembros = res.data);})
      .finally(() => {(this.isLoadingMembros = false);});      
    },           
    calculoRendaPerCapta(){            
      this.rendaBruta = 0;
      this.renda = 0;
      MembroFamiliarService.getMembrosRendaBrutaPerCaptaPorId(this.preMatricula.id).then((res) => {        
        this.rendaBruta = res.data;
        this.fmtrndbruta = this.rendaBruta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});         
      }),
      MembroFamiliarService.getMembrosRendaPerCaptaPorId(this.preMatricula.id).then((res) => {        
        this.renda = res.data;        
        this.fmtrndbrutapercapita = this.renda.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});         
      }),     
      this.fmtrndbrutapercapitareferencial = this.fmtrndbrutapercapitareferencial.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});          
    },
    formataEmReais(valor){
      return valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});    
    }
  },
};
</script>
